import { getCircleOBuilding } from '../../src_server/entity/master/buildingData';
import { ContextDTO } from '../../src_server/entity/dto/ContextDTO';
import { MessageDialog } from './MessageDialog';
/**
 * キーを限定するUNION型
 */
const DEFAULT_NICKNAME = 'Guest';
type SESSION_KEYS = 'SESSION' | 'USER' | 'MASTER' | 'ICONS' | 'STUDENT_INFO_INPUTING' | 'TEACHER_INFO_INPUTING' | 'TEACHER_SEARCH_CONDITION' | 'CONTEXT' | 'REPORT_CURRENT' | 'VERSION';
export class Session {
  static logout() {
    sessionStorage.clear();
  }
  static timeout() {
    sessionStorage.clear();
    MessageDialog.alert('セッションタイムアウトしました');
    location.reload();
  }

  static getContext(): ContextDTO | null {
    return this.get<ContextDTO>('CONTEXT');
  }
  static isProfielComplete() {
    const context = this.getContext();

    // NOTE: 2021/2/15 日本財団からの出資期間中なので、無償提供。カードは入力しないようにする。
    // return context?.is_complete && context?.is_input_card;
    return context?.is_complete;
  }
  /**
   *
   * @param key SESSION_KEYSに限定
   * @param val
   */
  static set<T>(key: SESSION_KEYS, val: T) {
    //valがobjならJSON化する
    if (val instanceof Object) {
      sessionStorage.setItem(key, JSON.stringify(val));
    } else {
      //存在するキーがあれば上書きする
      sessionStorage.setItem(key, `${val}`);
    }
  }

  static isExist(key: SESSION_KEYS): boolean {
    const data = sessionStorage.getItem(key);
    return data ? true : false;
  }

  static get<T>(key: SESSION_KEYS): T | null {
    const rawValue = sessionStorage.getItem(key);
    if (rawValue) {
      try {
        const item: T = JSON.parse(rawValue) as T;
        return item;
      } catch {
        return rawValue as any;
      }
    } else {
      return null;
    }
  }
  static getSessionUser() {
    const user = Session.get<any>('USER');
    if (!user) return {};
    return user;
  }

  static get isAuthorized(): boolean {
    const user = this.get<any>('USER');
    if (!user) return false;
    return user.user_id ? true : false;
  }

  static getSessionUserId(): string {
    return this.getSessionUser().user_id;
  }

  static getSessionUserType(): string {
    return this.getSessionUser().user_type;
  }

  static getSessionBuildingId(): string {
    const building = this.getSessionUser().building;
    return building || 'co01';
  }

  static getSessionNickName(): string {
    return this.getSessionUser().nickName;
  }

  static setLineNotifyToken(token: string) {
    const user = this.getSessionUser();
    user.line_notify_token = token;
    Session.set('USER', user);
  }

  static getJwtToken(): string {
    const user = this.getSessionUser();
    if (!user) {
      return '';
    }
    return user.token;
  }

  static isCircleOBuilding(): boolean {
    return this.getSessionBuildingId() === getCircleOBuilding();
  }

  // /**
  //  * セッションからデータを取り出す
  //  * @param key キー
  //  */
  // static get<T>(key: SESSION_KEYS): T {
  //   const rawValue = sessionStorage.getItem(key.toString());
  //   if (rawValue) {
  //     try {
  //       const item: T = JSON.parse(rawValue!) as T;
  //       return item;
  //     } catch (e) {
  //       throw Error(
  //         `セッションから取り出そうとした値が型変換できませんでした。${key} : ${rawValue}`
  //       );
  //     }
  //   } else {
  //     throw Error(
  //       `セッションから取り出そうとした値がnullでした。${key} : ${rawValue}`
  //     );
  //   }
  // }
}
